/* eslint-disable */
// @ts-nocheck

import {
  ListValue, 
	Value, 
	Struct
} from "@bufbuild/protobuf";
import * as reboot_api from "@reboot-dev/reboot-api";
import * as reboot_web from "@reboot-dev/reboot-web";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './registry_pb.js'
//
// You can resolve this by passing --web-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  DocumentCollabRegistry as DocumentCollabRegistryProto,
} from "./registry_pb";
import * as registry_pb from "./registry_pb";
// Additionally re-export all messages_and_enums from the pb module.
export {
  AttachedTable,
  CollabSessionInfo,
  DocumentCollabInfo,
  EnsureRegistryCreatedRequest,
  EnsureRegistryCreatedResponse,
  CreateNewPageRequest,
  CreateNewPageResponse,
  InitializeCollabStatesRequest,
  InitializeCollabStatesResponse,
  InitializeDocumentRequest,
  InitializeDocumentResponse,
  CollabSessionsRequest,
  CollabSessionsResponse,
} from "./registry_pb";

import * as protobuf_es from "@bufbuild/protobuf";

reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);

// Include all transitive imports.
import * as dev_moment_differential_v1alpha1_store from "../../differential/v1alpha1/store_pb";


const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const DocumentCollabRegistryInitializeCollabStatesRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<registry_pb.InitializeCollabStatesRequest>
): DocumentCollabRegistry.InitializeCollabStatesRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof registry_pb.InitializeCollabStatesRequest
    ? partialRequest
    : registry_pb.InitializeCollabStatesRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const DocumentCollabRegistryInitializeCollabStatesRequestFromJsonString = (
  jsonRequest: string
): DocumentCollabRegistry.InitializeCollabStatesRequest => {
  return DocumentCollabRegistryInitializeCollabStatesRequestFromProtobufShape(
    registry_pb.InitializeCollabStatesRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const DocumentCollabRegistryInitializeCollabStatesRequestToProtobuf = (
  partialRequest?: DocumentCollabRegistry.PartialInitializeCollabStatesRequest
): registry_pb.InitializeCollabStatesRequest => {
  return partialRequest instanceof registry_pb.InitializeCollabStatesRequest
    ? partialRequest
    : new registry_pb.InitializeCollabStatesRequest(
      partialRequest
    );
};

const DocumentCollabRegistryInitializeCollabStatesResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<registry_pb.InitializeCollabStatesResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof registry_pb.InitializeCollabStatesResponse
    ? partialResponse
    : registry_pb.InitializeCollabStatesResponse.fromJson(partialResponse);

  return response;
};

const DocumentCollabRegistryInitializeCollabStatesResponseToProtobuf = (
  partialResponse?: DocumentCollabRegistry.PartialInitializeCollabStatesResponse
): registry_pb.InitializeCollabStatesResponse => {
  return partialResponse instanceof registry_pb.InitializeCollabStatesResponse
    ? partialResponse
    : new registry_pb.InitializeCollabStatesResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const DocumentCollabRegistryEnsureRegistryCreatedRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<registry_pb.EnsureRegistryCreatedRequest>
): DocumentCollabRegistry.EnsureRegistryCreatedRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof registry_pb.EnsureRegistryCreatedRequest
    ? partialRequest
    : registry_pb.EnsureRegistryCreatedRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const DocumentCollabRegistryEnsureRegistryCreatedRequestFromJsonString = (
  jsonRequest: string
): DocumentCollabRegistry.EnsureRegistryCreatedRequest => {
  return DocumentCollabRegistryEnsureRegistryCreatedRequestFromProtobufShape(
    registry_pb.EnsureRegistryCreatedRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const DocumentCollabRegistryEnsureRegistryCreatedRequestToProtobuf = (
  partialRequest?: DocumentCollabRegistry.PartialEnsureRegistryCreatedRequest
): registry_pb.EnsureRegistryCreatedRequest => {
  return partialRequest instanceof registry_pb.EnsureRegistryCreatedRequest
    ? partialRequest
    : new registry_pb.EnsureRegistryCreatedRequest(
      partialRequest
    );
};

const DocumentCollabRegistryEnsureRegistryCreatedResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<registry_pb.EnsureRegistryCreatedResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof registry_pb.EnsureRegistryCreatedResponse
    ? partialResponse
    : registry_pb.EnsureRegistryCreatedResponse.fromJson(partialResponse);

  return response;
};

const DocumentCollabRegistryEnsureRegistryCreatedResponseToProtobuf = (
  partialResponse?: DocumentCollabRegistry.PartialEnsureRegistryCreatedResponse
): registry_pb.EnsureRegistryCreatedResponse => {
  return partialResponse instanceof registry_pb.EnsureRegistryCreatedResponse
    ? partialResponse
    : new registry_pb.EnsureRegistryCreatedResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const DocumentCollabRegistryCreateNewPageRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<registry_pb.CreateNewPageRequest>
): DocumentCollabRegistry.CreateNewPageRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof registry_pb.CreateNewPageRequest
    ? partialRequest
    : registry_pb.CreateNewPageRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const DocumentCollabRegistryCreateNewPageRequestFromJsonString = (
  jsonRequest: string
): DocumentCollabRegistry.CreateNewPageRequest => {
  return DocumentCollabRegistryCreateNewPageRequestFromProtobufShape(
    registry_pb.CreateNewPageRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const DocumentCollabRegistryCreateNewPageRequestToProtobuf = (
  partialRequest?: DocumentCollabRegistry.PartialCreateNewPageRequest
): registry_pb.CreateNewPageRequest => {
  return partialRequest instanceof registry_pb.CreateNewPageRequest
    ? partialRequest
    : new registry_pb.CreateNewPageRequest(
      partialRequest
    );
};

const DocumentCollabRegistryCreateNewPageResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<registry_pb.CreateNewPageResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof registry_pb.CreateNewPageResponse
    ? partialResponse
    : registry_pb.CreateNewPageResponse.fromJson(partialResponse);

  return response;
};

const DocumentCollabRegistryCreateNewPageResponseToProtobuf = (
  partialResponse?: DocumentCollabRegistry.PartialCreateNewPageResponse
): registry_pb.CreateNewPageResponse => {
  return partialResponse instanceof registry_pb.CreateNewPageResponse
    ? partialResponse
    : new registry_pb.CreateNewPageResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const DocumentCollabRegistryCollabSessionsRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<registry_pb.CollabSessionsRequest>
): DocumentCollabRegistry.CollabSessionsRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof registry_pb.CollabSessionsRequest
    ? partialRequest
    : registry_pb.CollabSessionsRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const DocumentCollabRegistryCollabSessionsRequestFromJsonString = (
  jsonRequest: string
): DocumentCollabRegistry.CollabSessionsRequest => {
  return DocumentCollabRegistryCollabSessionsRequestFromProtobufShape(
    registry_pb.CollabSessionsRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const DocumentCollabRegistryCollabSessionsRequestToProtobuf = (
  partialRequest?: DocumentCollabRegistry.PartialCollabSessionsRequest
): registry_pb.CollabSessionsRequest => {
  return partialRequest instanceof registry_pb.CollabSessionsRequest
    ? partialRequest
    : new registry_pb.CollabSessionsRequest(
      partialRequest
    );
};

const DocumentCollabRegistryCollabSessionsResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<registry_pb.CollabSessionsResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof registry_pb.CollabSessionsResponse
    ? partialResponse
    : registry_pb.CollabSessionsResponse.fromJson(partialResponse);

  return response;
};

const DocumentCollabRegistryCollabSessionsResponseToProtobuf = (
  partialResponse?: DocumentCollabRegistry.PartialCollabSessionsResponse
): registry_pb.CollabSessionsResponse => {
  return partialResponse instanceof registry_pb.CollabSessionsResponse
    ? partialResponse
    : new registry_pb.CollabSessionsResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const DocumentCollabRegistryInitializeDocumentRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<registry_pb.InitializeDocumentRequest>
): DocumentCollabRegistry.InitializeDocumentRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof registry_pb.InitializeDocumentRequest
    ? partialRequest
    : registry_pb.InitializeDocumentRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const DocumentCollabRegistryInitializeDocumentRequestFromJsonString = (
  jsonRequest: string
): DocumentCollabRegistry.InitializeDocumentRequest => {
  return DocumentCollabRegistryInitializeDocumentRequestFromProtobufShape(
    registry_pb.InitializeDocumentRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const DocumentCollabRegistryInitializeDocumentRequestToProtobuf = (
  partialRequest?: DocumentCollabRegistry.PartialInitializeDocumentRequest
): registry_pb.InitializeDocumentRequest => {
  return partialRequest instanceof registry_pb.InitializeDocumentRequest
    ? partialRequest
    : new registry_pb.InitializeDocumentRequest(
      partialRequest
    );
};

const DocumentCollabRegistryInitializeDocumentResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<registry_pb.InitializeDocumentResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof registry_pb.InitializeDocumentResponse
    ? partialResponse
    : registry_pb.InitializeDocumentResponse.fromJson(partialResponse);

  return response;
};

const DocumentCollabRegistryInitializeDocumentResponseToProtobuf = (
  partialResponse?: DocumentCollabRegistry.PartialInitializeDocumentResponse
): registry_pb.InitializeDocumentResponse => {
  return partialResponse instanceof registry_pb.InitializeDocumentResponse
    ? partialResponse
    : new registry_pb.InitializeDocumentResponse(
      partialResponse
    );
};



export namespace DocumentCollabRegistry {
  export type InitializeCollabStatesRequest =
    registry_pb.InitializeCollabStatesRequest;

  export type PartialInitializeCollabStatesRequest =
  protobuf_es.PartialMessage<registry_pb.InitializeCollabStatesRequest>;

  export type InitializeCollabStatesResponse =
    registry_pb.InitializeCollabStatesResponse;

  export type PartialInitializeCollabStatesResponse =
  protobuf_es.PartialMessage<registry_pb.InitializeCollabStatesResponse>;
}
export namespace DocumentCollabRegistry {
  export type EnsureRegistryCreatedRequest =
    registry_pb.EnsureRegistryCreatedRequest;

  export type PartialEnsureRegistryCreatedRequest =
  protobuf_es.PartialMessage<registry_pb.EnsureRegistryCreatedRequest>;

  export type EnsureRegistryCreatedResponse =
    registry_pb.EnsureRegistryCreatedResponse;

  export type PartialEnsureRegistryCreatedResponse =
  protobuf_es.PartialMessage<registry_pb.EnsureRegistryCreatedResponse>;
}
export namespace DocumentCollabRegistry {
  export type CreateNewPageRequest =
    registry_pb.CreateNewPageRequest;

  export type PartialCreateNewPageRequest =
  protobuf_es.PartialMessage<registry_pb.CreateNewPageRequest>;

  export type CreateNewPageResponse =
    registry_pb.CreateNewPageResponse;

  export type PartialCreateNewPageResponse =
  protobuf_es.PartialMessage<registry_pb.CreateNewPageResponse>;
}
export namespace DocumentCollabRegistry {
  export type CollabSessionsRequest =
    registry_pb.CollabSessionsRequest;

  export type PartialCollabSessionsRequest =
  protobuf_es.PartialMessage<registry_pb.CollabSessionsRequest>;

  export type CollabSessionsResponse =
    registry_pb.CollabSessionsResponse;

  export type PartialCollabSessionsResponse =
  protobuf_es.PartialMessage<registry_pb.CollabSessionsResponse>;
}
export namespace DocumentCollabRegistry {
  export type InitializeDocumentRequest =
    registry_pb.InitializeDocumentRequest;

  export type PartialInitializeDocumentRequest =
  protobuf_es.PartialMessage<registry_pb.InitializeDocumentRequest>;

  export type InitializeDocumentResponse =
    registry_pb.InitializeDocumentResponse;

  export type PartialInitializeDocumentResponse =
  protobuf_es.PartialMessage<registry_pb.InitializeDocumentResponse>;
}



const DOCUMENT_COLLAB_REGISTRY_INITIALIZE_COLLAB_STATES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type DocumentCollabRegistryInitializeCollabStatesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof DOCUMENT_COLLAB_REGISTRY_INITIALIZE_COLLAB_STATES_ERROR_TYPES
  >[number];

export class DocumentCollabRegistryInitializeCollabStatesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      DOCUMENT_COLLAB_REGISTRY_INITIALIZE_COLLAB_STATES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new DocumentCollabRegistryInitializeCollabStatesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new DocumentCollabRegistryInitializeCollabStatesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: DocumentCollabRegistryInitializeCollabStatesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: DocumentCollabRegistryInitializeCollabStatesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const DOCUMENT_COLLAB_REGISTRY_ENSURE_REGISTRY_CREATED_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type DocumentCollabRegistryEnsureRegistryCreatedAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof DOCUMENT_COLLAB_REGISTRY_ENSURE_REGISTRY_CREATED_ERROR_TYPES
  >[number];

export class DocumentCollabRegistryEnsureRegistryCreatedAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      DOCUMENT_COLLAB_REGISTRY_ENSURE_REGISTRY_CREATED_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new DocumentCollabRegistryEnsureRegistryCreatedAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new DocumentCollabRegistryEnsureRegistryCreatedAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: DocumentCollabRegistryEnsureRegistryCreatedAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: DocumentCollabRegistryEnsureRegistryCreatedAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const DOCUMENT_COLLAB_REGISTRY_CREATE_NEW_PAGE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type DocumentCollabRegistryCreateNewPageAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof DOCUMENT_COLLAB_REGISTRY_CREATE_NEW_PAGE_ERROR_TYPES
  >[number];

export class DocumentCollabRegistryCreateNewPageAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      DOCUMENT_COLLAB_REGISTRY_CREATE_NEW_PAGE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new DocumentCollabRegistryCreateNewPageAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new DocumentCollabRegistryCreateNewPageAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: DocumentCollabRegistryCreateNewPageAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: DocumentCollabRegistryCreateNewPageAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const DOCUMENT_COLLAB_REGISTRY_COLLAB_SESSIONS_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type DocumentCollabRegistryCollabSessionsAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof DOCUMENT_COLLAB_REGISTRY_COLLAB_SESSIONS_ERROR_TYPES
  >[number];

export class DocumentCollabRegistryCollabSessionsAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      DOCUMENT_COLLAB_REGISTRY_COLLAB_SESSIONS_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new DocumentCollabRegistryCollabSessionsAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new DocumentCollabRegistryCollabSessionsAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: DocumentCollabRegistryCollabSessionsAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: DocumentCollabRegistryCollabSessionsAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const DOCUMENT_COLLAB_REGISTRY_INITIALIZE_DOCUMENT_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type DocumentCollabRegistryInitializeDocumentAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof DOCUMENT_COLLAB_REGISTRY_INITIALIZE_DOCUMENT_ERROR_TYPES
  >[number];

export class DocumentCollabRegistryInitializeDocumentAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      DOCUMENT_COLLAB_REGISTRY_INITIALIZE_DOCUMENT_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new DocumentCollabRegistryInitializeDocumentAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new DocumentCollabRegistryInitializeDocumentAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: DocumentCollabRegistryInitializeDocumentAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: DocumentCollabRegistryInitializeDocumentAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


class _Reactively {
  #id: string;
  #state: string;

  constructor(id: string, options?: reboot_api.CallOptions) {
    this.#id = id;
    this.#state = "dev.moment.workspace.v1alpha1.DocumentCollabRegistry";
  }

  async collabSessions(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialCollabSessionsRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<DocumentCollabRegistry.CollabSessionsResponse, void, unknown>,
      (newRequest: DocumentCollabRegistry.PartialCollabSessionsRequest) => void
    ]> {
    const request = DocumentCollabRegistryCollabSessionsRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "CollabSessions",
        id: this.#id,
        requestType: registry_pb.CollabSessionsRequest,
        responseType: registry_pb.CollabSessionsResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
        websockets: context.websockets,
      }
    );

    const setTypedRequest = (newRequest: DocumentCollabRegistry.PartialCollabSessionsRequest): void => {
      const typedRequest = DocumentCollabRegistryCollabSessionsRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<DocumentCollabRegistry.CollabSessionsResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = DocumentCollabRegistryCollabSessionsResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

}

class _Idempotently {
  #stateRef: string;
  #idempotencyKey: string;

  constructor(id: string, idempotencyKey: string, options?: reboot_api.CallOptions) {
    this.#stateRef = reboot_api.stateIdToRef("dev.moment.workspace.v1alpha1.DocumentCollabRegistry", id);
    this.#idempotencyKey = idempotencyKey;
  }

  async initializeCollabStates(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialInitializeCollabStatesRequest,
    options?: { signal?: AbortSignal },
  ): Promise<DocumentCollabRegistry.InitializeCollabStatesResponse> {
    const request = DocumentCollabRegistryInitializeCollabStatesRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/InitializeCollabStates",
        stateRef: this.#stateRef,
        requestType: registry_pb.InitializeCollabStatesRequest,
        responseType: registry_pb.InitializeCollabStatesResponse,
        abortedType: DocumentCollabRegistryInitializeCollabStatesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return DocumentCollabRegistryInitializeCollabStatesResponseFromProtobufShape(responseProtobuf);
  }

  async ensureRegistryCreated(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialEnsureRegistryCreatedRequest,
    options?: { signal?: AbortSignal },
  ): Promise<DocumentCollabRegistry.EnsureRegistryCreatedResponse> {
    const request = DocumentCollabRegistryEnsureRegistryCreatedRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/EnsureRegistryCreated",
        stateRef: this.#stateRef,
        requestType: registry_pb.EnsureRegistryCreatedRequest,
        responseType: registry_pb.EnsureRegistryCreatedResponse,
        abortedType: DocumentCollabRegistryEnsureRegistryCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return DocumentCollabRegistryEnsureRegistryCreatedResponseFromProtobufShape(responseProtobuf);
  }

  async createNewPage(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialCreateNewPageRequest,
    options?: { signal?: AbortSignal },
  ): Promise<DocumentCollabRegistry.CreateNewPageResponse> {
    const request = DocumentCollabRegistryCreateNewPageRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/CreateNewPage",
        stateRef: this.#stateRef,
        requestType: registry_pb.CreateNewPageRequest,
        responseType: registry_pb.CreateNewPageResponse,
        abortedType: DocumentCollabRegistryCreateNewPageAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return DocumentCollabRegistryCreateNewPageResponseFromProtobufShape(responseProtobuf);
  }

}

export class DocumentCollabRegistryWeakReference {
  #id: string;
  #options?: reboot_api.CallOptions;

  constructor(id: string) {
    this.#id = id;
  }

  get stateId(): string {
    return this.#id;
  }

  public reactively() {
    return new _Reactively(
      this.#id,
    );
  }

  public idempotently({ key }: { key: string }) {
    return new _Idempotently(
      this.#id,
      key,
    );
  }


  async initializeCollabStates(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialInitializeCollabStatesRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<DocumentCollabRegistry.InitializeCollabStatesResponse> {

    const request = DocumentCollabRegistryInitializeCollabStatesRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.workspace.v1alpha1.DocumentCollabRegistry",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/InitializeCollabStates",
        stateRef: stateRef,
        requestType: registry_pb.InitializeCollabStatesRequest,
        responseType: registry_pb.InitializeCollabStatesResponse,
        abortedType: DocumentCollabRegistryInitializeCollabStatesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return DocumentCollabRegistryInitializeCollabStatesResponseFromProtobufShape(protobufResponse);
  }


  async ensureRegistryCreated(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialEnsureRegistryCreatedRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<DocumentCollabRegistry.EnsureRegistryCreatedResponse> {

    const request = DocumentCollabRegistryEnsureRegistryCreatedRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.workspace.v1alpha1.DocumentCollabRegistry",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/EnsureRegistryCreated",
        stateRef: stateRef,
        requestType: registry_pb.EnsureRegistryCreatedRequest,
        responseType: registry_pb.EnsureRegistryCreatedResponse,
        abortedType: DocumentCollabRegistryEnsureRegistryCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return DocumentCollabRegistryEnsureRegistryCreatedResponseFromProtobufShape(protobufResponse);
  }


  async createNewPage(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialCreateNewPageRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<DocumentCollabRegistry.CreateNewPageResponse> {

    const request = DocumentCollabRegistryCreateNewPageRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.workspace.v1alpha1.DocumentCollabRegistry",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/CreateNewPage",
        stateRef: stateRef,
        requestType: registry_pb.CreateNewPageRequest,
        responseType: registry_pb.CreateNewPageResponse,
        abortedType: DocumentCollabRegistryCreateNewPageAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return DocumentCollabRegistryCreateNewPageResponseFromProtobufShape(protobufResponse);
  }


  async collabSessions(
    context: reboot_web.WebContext,
    partialRequest?: DocumentCollabRegistry.PartialCollabSessionsRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<DocumentCollabRegistry.CollabSessionsResponse> {

    const request = DocumentCollabRegistryCollabSessionsRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.workspace.v1alpha1.DocumentCollabRegistry",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.workspace.v1alpha1.DocumentCollabRegistryMethods/CollabSessions",
        stateRef: stateRef,
        requestType: registry_pb.CollabSessionsRequest,
        responseType: registry_pb.CollabSessionsResponse,
        abortedType: DocumentCollabRegistryCollabSessionsAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return DocumentCollabRegistryCollabSessionsResponseFromProtobufShape(protobufResponse);
  }


}

export class DocumentCollabRegistry {

  static WeakReference = DocumentCollabRegistryWeakReference;

  public static ref(
    id: string,
    options?: { bearerToken?: string }
  ) {
    return new DocumentCollabRegistry.WeakReference(id, options?.bearerToken);
  }



}

export namespace DocumentCollabRegistry {
  export type WeakReference = typeof DocumentCollabRegistry.WeakReference.prototype;
}

